import React from "react";
import CorporateSocial from "../../components/AboutUs/CorporateSocial/CorporateSocial.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";

const Social: React.FC = () => {
  return (
    <div>
      <MetaComponent
        title="Vocational Training for Underprivileged Youth & CSR Policy in Education | Aptech Limited"
        desc="Learn how Aptech Limited supports underprivileged youth through impactful CSR education initiatives and inclusive vocational training programs."
        keywords="Skill development at Aptech, Aptech CSR Policies, Corporate Social Responsibility Aptech Ltd"
      />
      <CorporateSocial />
    </div>
  );
};

export default Social;
